import { render, staticRenderFns } from "./StunServer.vue?vue&type=template&id=e89f7ff6&scoped=true"
import script from "./StunServer.vue?vue&type=script&lang=js"
export * from "./StunServer.vue?vue&type=script&lang=js"
import style0 from "./StunServer.vue?vue&type=style&index=0&id=e89f7ff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89f7ff6",
  null
  
)

export default component.exports